import { render, staticRenderFns } from "./BackToTopCustom.vue?vue&type=template&id=0a3e01a8&"
import script from "./BackToTopCustom.vue?vue&type=script&lang=js&"
export * from "./BackToTopCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports